import checkForTouch from 'Models/check-for-touch';
// import { storeBrowser } from 'Models/detect-browser';
import initHashAnchorNavigation from 'Models/anchor-link';
// import initSentry from 'Models/init-sentry';
// initSentry();
checkForTouch();
// storeBrowser();
initHashAnchorNavigation();
